// PL
export const calendarHotel = {
  btn: {
    today: "Dzisiaj",
  },
  summary: {
    availableLabel: "Dostępne",
  },
  tooltip: {
    closed: "Zamknięte",
    dragToCreate: "Przeciągnij, aby zaznaczyć (utwórz rezerwację)",
  },
  labels: {
    room: "pokój",
    rooms: "pokoje",
    number: "NUMER:",
    capacityIconAlt: "Pojemność",
    maintenanceBadge: "SERWIS",
  },
  toasts: {
    reservationCreatedOk: "Rezerwacja została utworzona.",
    reservationCreateErrPrefix: "Nie udało się utworzyć rezerwacji: ",
    roomChangedOk: "Pokój został zmieniony",
    roomChangedErr: "Błąd przy zmianie pokoju",
    roomTypeChangedOk: "Rezerwacja przeniesiona do: {type}",
  },
  warn: {
    selectTwoDays: "Zaznacz co najmniej dwa dni (check-in i check-out).",
  },
  errors: {
    closedForBooking: "Nie można zarezerwować zamkniętego pokoju ani terminu.",
    noAvailabilityTitle: "Brak dostępności",
    noAvailabilityDetail: "W tych terminach nie ma wolnych pokoi tego typu.",
    noRatesTitle: "Brak przypisanych taryf",
    noRatesDetail: "W tych terminach nie ma dostępnych taryf dla tego typu.",
    missingDataTitle: "Brakujące dane",
    missingDataDetail: "Uzupełnij wszystkie wymagane pola.",
  },
  maintenanceModal: {
    titleFallback: "Pokój",
    statusSection: "Status",
    closeForMaintenance: "Zamknij na czas serwisu",
    open: "Otwarty",
    hint:
      "Pokój w trakcie serwisu nie może być sprzedawany, a jego komórki są oznaczone na czerwono. Istniejące rezerwacje pozostają bez zmian.",
    actions: {
      cancel: "Anuluj",
      save: "Zapisz",
      saving: "Zapisywanie…",
    },
  },

  // ===== NEW: Reservation modal =====
  modal: {
    title: "Zarejestruj nową rezerwację",
    startDate: "Check-in",
    endDate: "Check-out",
    roomType: "Typ pokoju",
    roomTypePlaceholder: "Wybierz typ",
    quantity: "Liczba pokoi",
    available: "dostępne",
    guestName: "Gość odpowiedzialny",
    guestNamePlaceholder: "Osoba odpowiedzialna za rezerwację",
    guests: "Liczba gości",
    guestsPlaceholder: "Liczba gości",
    phone: "Telefon",
    email: "E-mail",
    notes: "Notatka",
    notesPlaceholder: "Wewnętrzne notatki do rezerwacji (np. późny przyjazd, łóżeczko, alergie…)",
    addType: "Dodaj kolejny typ pokoju",
    price: "Cena",
    pricePlaceholder: "Wpisz cenę",
    cancel: "Anuluj",
    create: "Utwórz rezerwację",
  },

  // ===== Validations =====
  validation: {
    minGuestsTitle: "Za mało gości",
    minGuestsDetail: "Liczba pokoi: {rooms}. Wymagana minimalna liczba gości: {min}.",
    maxGuestsTitle: "Przekroczono limit gości",
    maxGuestsDetail: "Maksymalna liczba gości na pokój: {maxPerRoom} (łącznie {maxTotal} przy liczbie pokoi {rooms}).",
    maxRoomsTitle: "Przekroczono limit",
    maxRoomsDetail: "Nie można zarezerwować większej liczby pokoi niż {max}.",
  },

  // ===== Promotions & Taxes =====
  promotions: {
    limitTitle: "Osiągnięto limit",
    limitDetail: "Nie można dodać więcej niż 1 promocję.",
  },
  taxes: {
    limitTitle: "Osiągnięto limit",
    limitDetail: "Nie można dodać więcej niż 1 podatek.",
  },
};
